import type { SvgIconProps } from '@mui/material';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import FlagIcon from '@mui/icons-material/Flag';
import RoundaboutRightIcon from '@mui/icons-material/RoundaboutRight';
import StraightIcon from '@mui/icons-material/Straight';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import TurnRightIcon from '@mui/icons-material/TurnRight';
import TurnSharpLeftIcon from '@mui/icons-material/TurnSharpLeft';
import TurnSharpRightIcon from '@mui/icons-material/TurnSharpRight';
import TurnSlightLeftIcon from '@mui/icons-material/TurnSlightLeft';
import TurnSlightRightIcon from '@mui/icons-material/TurnSlightRight';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';

import { shapeOf, type TurnShape } from '../util/turnShape';

const ICONS: Record<TurnShape, typeof StraightIcon> = {
  start: TripOriginIcon,
  finish: FlagIcon,
  straight: StraightIcon,
  'slight-left': TurnSlightLeftIcon,
  left: TurnLeftIcon,
  'sharp-left': TurnSharpLeftIcon,
  'slight-right': TurnSlightRightIcon,
  right: TurnRightIcon,
  'sharp-right': TurnSharpRightIcon,
  uturn: UTurnLeftIcon,
  roundabout: RoundaboutRightIcon,
  ferry: DirectionsBoatIcon,
};

/**
 * Which way a turn goes, as a glyph.
 *
 * The same twelve shapes the exported PDF draws with lines — see `shapeOf` —
 * so a round read on screen and the same round read on paper agree about
 * every instruction. Here they are icons, because the browser has a set and
 * the PDF's standard fonts do not.
 */
export function TurnIcon(
  { type, ...props }: { type: number } & Omit<SvgIconProps, 'type'>,
) {
  const Icon = ICONS[shapeOf(type)];

  return <Icon fontSize="small" {...props} />;
}
